module.exports = __webpack_public_path__ + "static/img/newsjj.f54ef77.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsjj.png
// module id = aSlY
// module chunks = 45